import React from 'react';

import Layout from '@/components/v2/Layout';

import EnterpriseAccountInfo from './EnterpriseAccountinfo';
const EnterpriseAccount = () => {
  return (
    <Layout>
      <EnterpriseAccountInfo />
    </Layout>
  );
};

export default EnterpriseAccount;
